import { jsx as _jsx } from "react/jsx-runtime";
import CalendarControlled from "./CalendarControlled.js";
import CalendarUncontrolled from "./CalendarUncontrolled.js";
const Calendar = (props) => {
    if (props.value !== undefined)
        return _jsx(CalendarControlled, { ...props });
    return _jsx(CalendarUncontrolled, { ...props });
};
Calendar.displayName = "Calendar";
export default Calendar;
